import { useSelector } from 'react-redux';
import { RootState } from 'reducers/rootReducer';

const useViewConfig = () => {
    const viewConfig = useSelector((state: RootState) => state.viewConfig);
    return viewConfig;
};
export default useViewConfig;
